export const FORM_FIELD = {
  TEXT: {
    name: 'text',
    label: 'Text:',
    rules: [{ required: true, message: 'Text is required' }],
  },
};
